<template>
  <BaseModal :open="!!src" @update:open="updateSrc( '')" dialog-bg-transparent dialog-classes="sm:shadow-none">
    <div class="video-width">
      <video v-if="isBlob" :src="src" autoplay muted controls class="w-full h-full object-cover"/>
      <VideoPlayer v-else-if="src" :src="src" :title="title"/>
      <div v-if="prompt"
           class="absolute top-4 left-1/2 w-fit max-w-md -translate-x-1/2 rounded-full bg-black bg-opacity-50 px-3 text-center text-sm text-white py-1.5 z-[100]">
        {{ prompt }}
      </div>
    </div>
  </BaseModal>
</template>

<script setup>
import BaseModal from "./BaseModal.vue";
import VideoPlayer from "./VideoPlayer.vue";
import {computed} from "vue";

const emits = defineEmits(["update:src"]);
const props = defineProps({
  src: String,
  type: String,
  prompt: String,
  muted: Boolean,
  title: String
});

const isBlob = computed(() => props.src?.startsWith("blob:"));
const updateSrc = (src) => emits("update:src", src);
</script>

<style scoped>
.video-width {
  width: 1024px;
  max-width: 92vw;
  max-height: 92vw;
}
</style>
